import { z } from 'zod';

import { OrderDirection } from '@/constants/orderDirection';

/**
 * 一覧画面のフィルター用ソース種別
 * 共通定数 SourceType (data-pipeline/-constants.ts) の小文字版 + "all"
 */
export const SourceTypeFilter = {
  ALL: 'all',
  API: 'api',
  STORAGE: 'storage',
} as const;

export type SourceTypeFilterValue =
  (typeof SourceTypeFilter)[keyof typeof SourceTypeFilter];

export const SearchSchema = z.object({
  pageIndex: z.number().default(0),
  pageSize: z.number().default(100),
  sourceType: z
    .enum([
      SourceTypeFilter.ALL,
      SourceTypeFilter.API,
      SourceTypeFilter.STORAGE,
    ])
    .default(SourceTypeFilter.ALL),
  sortColumn: z.string().optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});
